@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1 data-automation-name="payloadIndex">Payloads</h1>
</div>
<p class="lead">
  Record of all sent payloads and their responses.
  To filter by payload sent time, populate the Start and/or End filter boxes with the time range you would like to search within.
</p>

@if(isLoading) {
  <app-loader
    message="Loading Payloads...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <tr>
      <th>ID</th>
      <th>VEN ID</th>
      <th>Request ID</th>
      <th>Sent Time</th>
      <th>Sent Type</th>
      <th>Received Time</th>
      <th>Received Type</th>
      <th>Actions</th>
    </tr>
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Ven Id" class="input-sm form-control" type="search" [(ngModel)]="venIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Request Id" class="input-sm form-control" type="search" [(ngModel)]="requestIdSearch" (input)="triggerSearch()"/></th>
      <th>
        <input placeholder="Start Time" class="input-sm form-control" type="search" [(ngModel)]="startTimeSearch" (input)="triggerSearch()"/>
        <input placeholder="End Time" class="input-sm form-control" type="search" [(ngModel)]="endTimeSearch" (input)="triggerSearch()"/>
      </th>
      <th><input placeholder="Sent Type" class="input-sm form-control" type="search" [(ngModel)]="sentTypeSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th><input placeholder="Received Type" class="input-sm form-control" type="search" [(ngModel)]="receivedTypeSearch" (input)="triggerSearch()"/></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      @for(payload of displayedPayloads | paginate: paginationModel; track payload) {
        <tr>
          <td>{{payload.id}}</td>
          <td>{{payload.ven_id}}</td>
          <td>{{payload.request_id}}</td>
          <td>{{payload.sent_dttm}}</td>
          <td>{{payload.sent_type}}</td>
          <td>{{payload.received_dttm}}</td>
          <td>{{payload.received_type}}</td>
          <td><a class="btn btn-default" (click)="clickDetailPayloadPage(payload.id, '/viewPayload', router)" name="viewPayload">View</a></td>
        </tr>
      }
      @if(displayedPayloads.length <= 0) {
        <tr>
          <td colspan="8" style="text-align: center;">No payloads found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" colspan="8">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
